module.exports = __webpack_public_path__ + "img/printer.3959a7ab.png";